import type { SVGProps } from 'react';

const SvgDeletionDelete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M10 11c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1m4 0c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1"
    />
    <path
      fill="currentcolor"
      d="M19 7h-2V6c0-1.65-1.35-3-3-3h-4C8.35 3 7 4.35 7 6v1H5c-.55 0-1 .45-1 1s.45 1 1 1v9c0 1.65 1.35 3 3 3h8c1.65 0 3-1.35 3-3V9c.55 0 1-.45 1-1s-.45-1-1-1M9 6c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1H9zm8 12c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V9h10z"
    />
  </svg>
);
export default SvgDeletionDelete;
